import { render, staticRenderFns } from "./SearchDeferredWorkPage.vue?vue&type=template&id=2c23bdfe&"
import script from "./SearchDeferredWorkPage.vue?vue&type=script&lang=js&"
export * from "./SearchDeferredWorkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports